const version = '(v10.05)'

export default version
